<template>
  <footer class="l-the-footer">
    <div class="tlpf-languages">
      <i><img src="https://bs.benefit-one.inc/contents/img/ats/icon_global-outlined.svg"
        alt="" width="28" height="28" /></i>
      <span class="tlpf-switch" :class="{ selected: activeLang === 'ja' }"
        data-value="ja" @click="activeLang !== 'ja' && switchLang('ja')">日本語</span>
      <span>|</span>
      <span class="tlpf-switch" :class="{ selected: activeLang === 'en' }"
        data-value="en" @click="activeLang !== 'en' && switchLang('en')">English</span>
    </div>
    <div class="p-the-footer">
      <div class="c-common-inner">
        <div
          class="p-the-footer__inner"
          :class="{
            'p-the-footer__inner--not_login': !footers.site_id
          }"
        >
          <div
            class="p-the-footer__content"
            v-if="
              footers.site_id &&
                checkSelectContractFlag === null &&
                checkExpiredContractDate === null &&
                checkNotContractedIc === null &&
                !footer_hidden_flag
            "
          >
            <div class="p-the-footer__left">
              <!-- TODO: リンク追加 -->
              <a
                :href="urls.whitePaper" class="p-the-footer__link"
                target="_blank"
                >ホワイトペーパー</a
              >
              <br />
              <a
                style="display: inline-block; margin-top: 20px"
                :href="urls.travelAgencyLaw" class="p-the-footer__link"
                target="_blank"
                >旅行業法に基づく営業所の表示</a
              >
              <br />
              <a
                style="display: inline-block; margin-top: 20px"
                :href="urls.privacyPolicy"
                target="_blank"
                class="p-the-footer__link"
                >プライバシーポリシー</a
              >
              <div class="p-the-footer__maintenance">
                <p>システムメンテナンス</p>
                <p>
                  AM2:00～5:00の時間内は、メンテナンスのためご利用いただけません。
                </p>
              </div>
              <p class="p-the-footer__site_id">
                サイトID {{ footers.site_id }}
              </p>
            </div>
            <div class="p-the-footer__right">
              <!-- TODO: リンク追加 -->
              <a
                style="display: inline-block"
                :href="termsUrl"
                target="_blank"
                class="p-the-footer__link"
                >利用規約</a
              >
              <br />
              <a :href="urls.enquiryLink" class="p-the-footer__link" style="margin-top: 20px"
                >商品に関するお問い合わせ</a
              >
              <br />
              <div
                class="p-the-footer__contact"
                v-if="displayDepartmentName || displayEmail || displayTel"
              >
                <p class="p-the-footer__link">
                  商品以外に関するお問い合わせ先
                </p>
                <div data-translate-skip>
                  <p v-if="displayDepartmentName">
                    {{ footers.department_name }}
                  </p>
                  <div
                    v-if="displayEmail"
                  >
                    <p>
                      {{ footers.email_address }}
                    </p>
                  </div>
                  <div
                    v-if="displayTel"
                  >
                    <p>
                      {{ footers.telephone_number }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="p-the-footer__content" v-else-if="!footer_hidden_flag">
            <div class="p-the-footer__maintenance">
              <p>システムメンテナンス</p>
              <p>
                AM2:00～5:00の時間内は、メンテナンスのためご利用いただけません。
              </p>
            </div>
          </div>
          <p class="p-the-footer__copyright">
            Copyright(C) 2020 Benefit-one Inc. All rights reserved
          </p>
        </div>
      </div>
    </div>
  </footer>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';
import { FooterInfo } from "@/general/store/models";
import commons from "@/common/store/modules/commons";
import { getFooterInfo } from "@/general/store/api";
import auth from "@/general/store/modules/auth";
import LocalStorage from "@/general/utils/storage";

@Options({
  name: "TheFooter",
})
export default class TheFooter extends Vue {
  footers: FooterInfo = {} as FooterInfo;
  footer_hidden_flag = false;
  activeLang = "ja";

  get companyCd() {
    let companyCode: string = auth.user.company_code;
    if (companyCode == null) {
      const userDetailJson = LocalStorage.getItem("userDetails");
      if (userDetailJson) {
        const userDetail = JSON.parse(userDetailJson);
        companyCode = userDetail.company_code;
      }
    }
    return companyCode;
  }

  get host(): any {
    return process.env.VUE_APP_BS_DOMAIN;
  }

  get urls() {
    return {
      whitePaper: `${this.host}/contents/kiyaku/security/security_white_paper.pdf`,
      travelAgencyLaw: `${this.host}/contents/kiyaku/travel_agency_law/`,
      privacyPolicy: `${this.host}/contents/kiyaku/privacy/`,
      enquiryLink: `${this.host}/contents/cgi/memberfaqic/index.html`
    };
  }

  get termsUrl(): string {
    return `${process.env.VUE_APP_API_DOMAIN}/api/terms_of_use_doc`;
  }

  async created() {
    const path = location.pathname;
    console.debug(path);
    // logoutはSSOログアウト専用、session-time-outはだし分けが必要だが、
    // フッターを表示するのはSSOの場合のみなので、フッター表示をSSOに合わせて変更して問題なし
    const NO_FOOTER_URL = ["/logout/", "/session-time-out/"];

    let footer = null;

    // 非認証画面で、認証が必要なリクエストが飛ばないための分岐
    if (NO_FOOTER_URL.includes(path)) {
      this.footer_hidden_flag = true;
    } else {
      footer = await getFooterInfo(this.companyCd);
      await commons.setFooter(footer);
    }

    if (!footer) {
      return {
        department_name: "",
        email_address: "",
        telephone_number: "",
        membership_term_url: "",
        display_department_name: false,
        display_email_address: false,
        display_telephone_number: false,
        site_id: ""
      };
    }

    footer.membership_term_url =
      footer.membership_term_url === null
        ? `https://icpt-ric.tst.benefit-one.inc/static/profiles/files/standard_agreement.docx`
        : footer.membership_term_url;
    this.footers = footer;
  }
  get displayEmail() {
    return this.footers.display_email_address;
  }
  get displayTel() {
    return this.footers.display_telephone_number;
  }
  get displayDepartmentName() {
    return this.footers.display_department_name;
  }

  get checkSelectContractFlag() {
    const selectContractFlag = LocalStorage.getItem("selectContractFlag");
    return selectContractFlag;
  }

  get checkExpiredContractDate() {
    const expiredContractDateFlag = LocalStorage.getItem(
      "expiredContractDateFlag"
    );
    return expiredContractDateFlag;
  }

  get checkNotContractedIc() {
    const notContractedIc = LocalStorage.getItem("notContractedIc");
    return notContractedIc;
  }
  
  mounted() {
  const lang = localStorage.getItem("tlpf_locale");
   
  this.activeLang = lang === "en" ? "en" : "ja";
  }
  
  switchLang(lang: string) {
    this.activeLang = lang;
    localStorage.setItem("tlpf_locale", lang);

    if ((window as any).TLPF && typeof (window as any).TLPF.translateAll === "function") {
      (window as any).TLPF.translateAll(lang);
    }
  }
}
</script>

<style lang="scss" scoped>
.p-the-footer {
  @include sp {
    min-width: rem($min-width--s);
  }

  background-color: $common-black;
  min-width: rem($min-width--m);

  &__inner {
    color: $common-white;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: rem(32) 0 rem(20);

    @include sp {
      padding: rem(24) rem(20) rem(16);
      align-items: flex-start;
    }

    &--not_login {
      padding-top: rem(20);

      @include sp {
        padding-top: rem(16);
      }
    }
  }

  &__content {
    @include text__body--xs;
    color: $common-gray500;
    display: flex;

    @include sp {
      display: block;
    }
  }

  &__left {
    margin-right: rem(40);
  }

  &__right {
    @include sp {
      margin-top: rem(32);
    }
  }

  &__link {
    @include text__body--s;
    font-weight: bold;
    color: $common-white;
  }

  &__maintenance {
    margin-top: rem(16);

    &:first-child {
      margin-top: 0;
    }
  }

  &__site_id {
    margin-top: rem(16);
  }

  &__contact {
    margin-top: rem(20);
  }

  &__copyright {
    @include text__body--xs;
    margin-top: rem(16);
    color: $common-gray500;
  }
}

.tlpf-languages {
  color: #73767A;
  display: flex!important;
  align-items: center;
  gap: 6px;
  justify-content: center;
  padding: rem(16) 0;
}
.tlpf-languages i {
  align-self: center;
  display: flex;
}
.tlpf-languages img {
  display: inline-block;
  max-width: 14px;
  height: auto;
}
.tlpf-languages .tlpf-switch {
  cursor: pointer;
}
.tlpf-switch:hover {
  color: #da291c;
}
.tlpf-switch.selected {
  cursor: unset;
  color: #1F2021;
}
</style>
